export default {
  // b0b23ee5-92a6-4d0e-b327-6c3b25697a7f 模型
  search: {
    ti: 'title', // 标题-统计字段
    ab: 'abstract_ab', // 摘要
    clms: 'claims', // 权利要求
    desc: 'description', // 说明书
    ta: 'TA', // 标题+摘要 这个拼接为TA('value')
    tac: 'TAC', // 标题+摘要+权利要求 这个拼接为TAC('value')
    apd: 'application_date', // 申请日
    pd: 'publication_date', // 公开（公告）日
    ap: 'application_num', // 申请号
    ap_s: 'application_num_sear', // 申请号(精准检索)
    pn: 'publication_number', // 公开（公告）号
    pn_s: 'publication_number_sear', // 公开（公告）号(精准检索)
    pr: 'priority_num', // 优先权号pd
    pa: 'applicants', // 申请人
    pae: 'applicants_stat', // 申请人（精确）
    paes: 'applicant_stand', // 申请人（标准化）
    in: 'inventors', // 发明人
    ine: 'inventors_stat', // 发明人（精确）
    at: 'agent', // 代理人
    ate: 'agent_stat', // 代理人（精确）
    agc: 'agency', // 专利代理机构
    agce: 'agency_stat', // 专利代理机构（精确）
    asg: 'assignees', // 专利权人
    asg_s: 'assignees_stat', // 专利权人-统计字段
    ic: 'ipc', // 国际分类号
    mic: 'ipc_main', // 主分类号
    mic_s: 'ipc_main_stat', // 主分类号-统计字段
    cic: 'icnea_type', // 国民经济分类
    loc: 'loc', // 洛迦诺分类号
    cpc: 'cpc', // CPC分类号
    upc: '', // UC分类号
    fi: '', // FI分类号
    ft: '', // F-cpc_num_fiterm分类号
    paad: 'applicant_addr', // 申请人地址
    lsc_s: 'last_legal_status_stat', // 最新法律状态
    psc: 'patent_status', // 专利状态
    psc_s: 'patent_status_stat', // 专利状态-统计字段
    pat: 'applicant_type', // 申请人类型
    pat_s: 'applicant_type_stat', // 申请人类型-统计字段
    paq: 'applicants_count', // 申请人数量
    pt: 'patent_type', // 专利类型
    pt_s: 'patent_type_stat', // 专利类型-统计字段
    pdt: 'patent_duration', // 专利维持期
    prv: 'expired_date', // 剩余有效期
    pbt: 'publication_type', // 文献类型
    pbt_s: 'publication_type_stat', // 文献类型-统计字段
    awn: 'award_name', // 奖励名称
    awn_s: 'award_name_stat', // 奖励名称-统计字段
    aws: 'award_sess', // 奖励届次
    aws_s: 'award_sess_stat', // 奖励届次-统计字段
    // =====以上部分为帮助中心提供的字段 为简写==========================
    source: 'datasource', // 数据源
    source_s: 'datasource_stat', // 数据源-统计字段
    //  ======================
    applicationYear: 'application_year_stat', // 申请年
    publicYear: 'publication_year_stat', // 公开年
    publicMonth: 'publication_month', // 公开月
    applicationMonth: 'application_month', // 申请月
    icd: 'ipc_section_stat', // ipc部分类-统计字段
    icbc: 'ipc_mainclass_stat', // ipc大类-统计字段
    icmc: 'ipc_subclass_stat', // ipc小类-统计字段
    icbg: 'ipc_maingroup_stat', // ipc大组-统计字段
    icmg: 'ipc_subgroup_stat', // ipc小组-统计字段
    nds: 'icnea1_stat', // 国民经济门类-统计字段（产业门类）
    bgs: 'icnea2_stat', // 国民经济大类-统计字段（产业大类）
    nms: 'icnea3_stat', // 国民经济中类-统计字段（产业中类）
    nss: 'icnea4_stat', // 国民经济小类-统计字段（产业小类）
    cname: 'country_name_stat', // 申请人国家
    pcname: 'publication_country_stat' // 公开国
    // pcname: 'application_country_stat' // 专利申请国家
  },
  // 其他模型未改字段
  search1: {
    ti: 'patent_tittle', // 标题-统计字段
    ab: 'summary', // 摘要
    clms: 'right_require', // 权利要求
    desc: 'description', // 说明书
    ta: 'TA', // 标题+摘要 这个拼接为TA('value')
    tac: 'TAC', // 标题+摘要+权利要求 这个拼接为TAC('value')
    apd: 'application_date', // 申请日
    pd: 'public_date', // 公开（公告）日
    ap: 'application_num', // 申请号
    ap_s: 'application_num_sear', // 申请号(精准检索)
    pn: 'public_num', // 公开（公告）号
    pn_s: 'public_num_sear', // 公开（公告）号(精准检索)
    pr: 'priority_num', // 优先权号
    pa: 'applicants', // 申请人
    pae: 'applicants_stat', // 申请人（精确）
    paes: 'applicant_stand', // 申请人（标准化）
    in: 'inventors', // 发明人
    ine: 'inventors_stat', // 发明人（精确）
    at: 'agent', // 代理人
    ate: 'agent_stat', // 代理人（精确）
    agc: 'agency', // 专利代理机构
    agce: 'agency_stat', // 专利代理机构（精确）
    asg: 'assignees', // 专利权人
    asg_s: 'assignees_stat', // 专利权人-统计字段
    ic: 'ipc', // 国际分类号
    mic: 'main_ipc_num', // 主分类号
    mic_s: 'main_ipc_num_stat', // 主分类号-统计字段
    cic: 'national_type', // 国民经济分类
    loc: 'loc', // 洛迦诺分类号
    cpc: 'cpc', // CPC分类号
    upc: '', // UC分类号
    fi: '', // FI分类号
    ft: '', // F-cpc_num_fiterm分类号
    paad: 'applicant_addr', // 申请人地址
    lsc_s: 'new_law_status_stat', // 最新法律状态
    psc: 'patent_stat', // 专利状态
    psc_s: 'patent_stat_stat', // 专利状态-统计字段
    pat: 'applicant_type', // 申请人类型
    pat_s: 'applicant_type_stat', // 申请人类型-统计字段
    paq: 'applicants_count', // 申请人数量
    pt: 'patent_type', // 专利类型
    pt_s: 'patent_type_stat', // 专利类型-统计字段
    pdt: 'patent_duration', // 专利维持期
    prv: 'expired_date', // 剩余有效期
    pbt: 'liter_type', // 文献类型
    pbt_s: 'liter_type_stat', // 文献类型-统计字段
    awn: 'award_name', // 奖励名称
    awn_s: 'award_name_stat', // 奖励名称-统计字段
    aws: 'award_sess', // 奖励届次
    aws_s: 'award_sess_stat', // 奖励届次-统计字段
    // =====以上部分为帮助中心提供的字段 为简写==========================
    source: 'datasource', // 数据源
    source_s: 'datasource_stat', // 数据源-统计字段
    //  ======================
    applicationYear: 'application_year_stat', // 申请年
    publicYear: 'public_year_stat', // 公开年
    publicMonth: 'public_month', // 公开月
    applicationMonth: 'application_month', // 申请月
    icd: 'ipc_section_stat', // ipc部分类-统计字段
    icbc: 'ipc_mainclass_stat', // ipc大类-统计字段
    icmc: 'ipc_smal_cla_stat', // ipc小类-统计字段
    icbg: 'ipc_maingroup_stat', // ipc大组-统计字段
    icmg: 'ipc_subgroup_stat', // ipc小组-统计字段
    nds: 'nat_door_stat', // 国民经济门类-统计字段（产业门类）
    bgs: 'nat_big_stat', // 国民经济大类-统计字段（产业大类）
    nms: 'nat_mid_stat', // 国民经济中类-统计字段（产业中类）
    nss: 'nat_sma_stat', // 国民经济小类-统计字段（产业小类）
    cname: 'country_name_stat', // 申请人国家
    pcname: 'patent_country_stat' // 专利申请国家
  },
  other: {
    patentNum: 'patent_num' // 专利数量
  }
}
